import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  ClickAwayListener,
  Container,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { languageApiData, stepperData } from "../../../constant/appConstant";
import fetcher from "../../../dataProvider";
import {
  setJourneyText,
  setLoading,
  setSelectedCountry,
  setStepData,
  setToastData,
} from "../../../redux/slices/customerJourney";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { useNavigate } from "react-router-dom";
import { setOneTrustLanguage } from "../../../utils/setOneTrustLanguage";
import HeaderTitle from "./HeaderTitle";
import HeaderMenu from "./HeaderMenu";
import HeaderMobileMenu from "./HeaderMobileMenu";
import { SelectedCountry } from "../../../types/common";
import { getSelectedCountry } from "../../../utils/common";

const Header = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const customerData = useAppSelector((state) => state.customerJourney);
  const {
    selectedCountry: country,
    pageLanguages,
    stepData,
    pageText,
  } = customerData;
  const examDataStore = useAppSelector((state) => state.examDetails);
  const { examRulesData } = examDataStore;

  useEffect(() => {
    const links = document.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });
  }, [stepData, examRulesData]);

  const redirectHome = () => {
    sessionStorage.clear();
    dispatch(setStepData({ data: stepperData[0] }));
    sessionStorage.setItem("currentStep", JSON.stringify(stepperData[0]));
    navigate("/rex-cj");
    navigate(0);
  };

  const fetchLanguageData = async (item: any) => {
    dispatch(setLoading({ loading: true }));
    setOneTrustLanguage(item?.languageCode ?? "en-GB");

    try {
      let body = {};
      if (item) {
        body = {
          ...languageApiData,
          alias: country?.label,
          languageCode: item.languageCode,
        };
      } else {
        body = {
          ...languageApiData,
          languageCode: "en-GB",
        };
      }
      const { data } = await fetcher.post("/api/Home", body);
      let language: any = sessionStorage.getItem("defaultLanguage");
      if (item) {
        language = JSON.parse(language);
        language = language.map((subItem: any) => {
          if (subItem.languageCode === item.languageCode) {
            subItem.isDefault = true;
          } else {
            subItem.isDefault = false;
          }
          return subItem;
        });
        sessionStorage.setItem("defaultLanguage", JSON.stringify(language));
      }
      dispatch(
        setJourneyText({
          data: {
            ...data,
            languages: language && language !== "null" ? language : [],
          },
        })
      );
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("error", e);
      dispatch(setLoading({ loading: false }));
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const getHomePageText = async () => {
    await dispatch(setLoading({ loading: true }));
    let language: any = sessionStorage.getItem("defaultLanguage");
    language = JSON.parse(language);
    const country = getSelectedCountry();
    dispatch(setSelectedCountry({ country }));
    const languageData = language?.filter((item: any) => item.isDefault);
    setOneTrustLanguage(languageData[0]?.languageCode);
    try {
      let body = {
        ...languageApiData,
        alias: country?.label,
        languageCode: languageData[0]?.languageCode,
      };
      const { data } = await fetcher.post("/api/Home", body);
      dispatch(setJourneyText({ data: { ...data, languages: language } }));
      dispatch(setLoading({ loading: false, id: 12 }));
    } catch (e) {
      console.log("error", e);
      dispatch(setLoading({ loading: false }));
    }
  };

  useEffect(() => {
    let data: any = sessionStorage.getItem("currentStep");
    data = JSON.parse(data);
    if (data && data?.value !== "location") {
      getHomePageText();
    } else {
      fetchLanguageData("");
    }
  }, []);

  const showMenu = pageLanguages && !!pageLanguages?.length;

  return (
    <AppBar elevation={0}>
      <ClickAwayListener onClickAway={() => setMobileOpen(false)}>
        <Container disableGutters maxWidth="xl">
          <Toolbar sx={{ gap: 2.5 }} component="nav">
            <HeaderTitle
              isMobile={isMobile}
              country={country}
              onClick={redirectHome}
            />

            {showMenu && !isMobile && (
              <HeaderMenu
                pageLanguages={pageLanguages}
                onClick={(item) => {
                  if (!item?.isDefault) {
                    fetchLanguageData(item);
                  }
                }}
                onHomeIconClick={redirectHome}
              />
            )}

            {showMenu && isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={() => {
                  setMobileOpen(!mobileOpen);
                }}
                sx={{ paddingRight: 0 }}
              >
                {mobileOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            )}
          </Toolbar>

          {mobileOpen && isMobile && (
            <HeaderMobileMenu
              pageLanguages={pageLanguages}
              onClick={(item) => {
                if (!item?.isDefault) {
                  fetchLanguageData(item);
                }
                setMobileOpen(false);
              }}
              onHomeIconClick={() => {
                redirectHome();
                setMobileOpen(false);
              }}
            />
          )}
        </Container>
      </ClickAwayListener>
    </AppBar>
  );
};

export default Header;
